module.exports = __webpack_public_path__ + "static/media/imageStep.6faff879.svg";